var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#495057"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49935 19.5C6.49935 19.5 5.41602 19.5 5.41602 18.4167C5.41602 17.3333 6.49935 14.0833 11.916 14.0833C17.3327 14.0833 18.416 17.3333 18.416 18.4167C18.416 19.5 17.3327 19.5 17.3327 19.5H6.49935ZM11.916 13C12.778 13 13.6046 12.6576 14.2141 12.0481C14.8236 11.4386 15.166 10.612 15.166 9.75C15.166 8.88805 14.8236 8.0614 14.2141 7.4519C13.6046 6.84241 12.778 6.5 11.916 6.5C11.0541 6.5 10.2274 6.84241 9.61792 7.4519C9.00843 8.0614 8.66602 8.88805 8.66602 9.75C8.66602 10.612 9.00843 11.4386 9.61792 12.0481C10.2274 12.6576 11.0541 13 11.916 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6396 10.1274H22.7507V11.322H20.6396V13.4221H19.445V11.322H17.334V10.1274H19.445V8H20.6396V10.1274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.12818e7a441e1ae0c129c2e196b35a0c.svg";
export { ForwardRef as ReactComponent };